import { api } from './api';
import type {
  FulfillmentWithRelations,
  FulfillPrescriptionInput,
  FulfillmentResult,
  PaginatedResponse,
  PrescriptionRemaining,
} from '@dpfs/shared';

export interface FulfillmentHistoryParams {
  page?: number;
  limit?: number;
  fromDate?: string;
  toDate?: string;
}

export const fulfillmentService = {
  async fulfill(
    prescriptionId: string,
    input: FulfillPrescriptionInput = {}
  ): Promise<FulfillmentResult> {
    const response = await api.post(`/fulfillment/${prescriptionId}/fulfill`, input);
    return response.data;
  },

  async getHistory(
    params: FulfillmentHistoryParams = {}
  ): Promise<PaginatedResponse<FulfillmentWithRelations>> {
    const response = await api.get('/fulfillment/history', { params });
    return response.data;
  },

  async getById(id: string): Promise<FulfillmentWithRelations> {
    const response = await api.get(`/fulfillment/${id}`);
    return response.data;
  },

  async getRemainingItems(prescriptionId: string): Promise<PrescriptionRemaining> {
    const response = await api.get(`/fulfillment/${prescriptionId}/remaining`);
    return response.data;
  },
};
